import axios from "axios";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { BASE_URL } from "../Const/Url";
import Select from "react-select";

import DeleteIcon from "../CustomCommons/DeleteIcon";
import Loader from "../CustomCommons/Loader";

import ReactPaginate from "react-paginate";

import PreviousIcon from "../CustomCommons/PreviousIcon";
import NextIcon from "../CustomCommons/NextIcon";
import {
  can_delete_report,
  can_view_report,
  has_permissions,
} from "../CustomCommons/utils";
import Permission from "../CustomCommons/Permission";
import { useReactToPrint } from "react-to-print";
import { logout_func2 } from "../Const/logoutCommon";
import HelperExportComponent from "../../utils/HelperExportComponent";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const OutletCashReport = ({ limit_data }) => {
  const [date1, setDate1] = useState("");
  const [date2, setDate2] = useState("");
  const convertPickerDateToApiDate = (formattedDate) => {
    if (!formattedDate) return "";
    const [month, day, year] = formattedDate.split("/");
    return `${month}/${day}/${year}`;
  };
  const [query, setQuery] = useState("");
  const [totalSale, setTotalSale] = useState(0);
  const history = useHistory();
  const [OnlogoutHide, setOnlogoutHide] = useState(0);
  const date = new Date();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let currentDate = `${month}-${day}-${year}`;
  const [mainReportLength, setMainReportLength] = useState(0);

  const updatedPageNumber = parseInt(
    localStorage.getItem("saleReportPageNbr")
      ? localStorage.getItem("saleReportPageNbr")
      : 0
  );
  const [pageNumber, setPageNumber] = useState(updatedPageNumber);
  const usersPerPage = limit_data ? limit_data : 15;
  const pagesVisited = pageNumber * usersPerPage;
  var options = {
    day: "numeric",
    year: "numeric",
    month: "numeric",
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingOutlets, setIsLoadingOutlets] = useState(true);
  const [Showdata, setShowdata] = useState(true);
  const cRef = useRef();

  

  const [dailyReport, setDailyReport] = useState([]);
  const [dailyReportAll, setDailyReportAll] = useState({});

  const userProfile = JSON.parse(window.localStorage.getItem("userData"));
  const userOutletId =
    userProfile?.outlet?.id ||
    userProfile?.outlet_id ||
    userProfile?.outletId ||
    userProfile?.outlet ||
    null;

  const [outletList, setOutletList] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState("");

  // Effective outlet used for all API calls:
  // - Prefer explicitly selected outlet from dropdown
  // - Fallback to the user's outlet from profile (if any)
  const effectiveOutletId = selectedOutlet || userOutletId;

  /**
   * Load outlets for dropdown and set a sensible default:
   * - If user's outlet exists in profile, select that
   * - Otherwise, pick the first outlet from the API response
   */
  const getOutletList = () => {
    setIsLoadingOutlets(true);
    const url = `${BASE_URL}api/v1/sales/admin/outlet/`;
    axios
      .get(url)
      .then((res) => {
        const result = res?.data?.data?.results || [];
        const outletOptions = result.map((outlet) => ({
          label: outlet?.name,
          value: outlet?.id,
        }));

        setOutletList(outletOptions);

        setSelectedOutlet((currentSelected) => {
          if (currentSelected) return currentSelected;
          const matchedUserOutlet = outletOptions.find(
            (opt) => opt.value === userOutletId
          );
          if (matchedUserOutlet) return matchedUserOutlet.value;
          return outletOptions?.[0]?.value || "";
        });
        setIsLoadingOutlets(false);
      })
      .catch((err) => {
        console.log(err?.request?.response || err);
        setIsLoadingOutlets(false);
      });
  };

  const handleOutletChange = (newOutletOption) => {
    setSelectedOutlet(newOutletOption?.value || "");
    setPageNumber(0);
  };

  const fetchReport = (startDate, endDate, outletId = null) => {
    // Use provided outletId or fallback to effectiveOutletId
    const outletToUse = outletId || effectiveOutletId;
    
    // Don't fetch if no outlet is selected yet
    if (!outletToUse) {
      return;
    }

    setIsLoading(true);
    let url;
    if (startDate && endDate) {
      url = `${BASE_URL}api/v1/sales/inventory/daily-cash-report/outlet/?start=${startDate}&end=${endDate}&outlet=${outletToUse}`;
    } else {
      url = `${BASE_URL}api/v1/sales/inventory/daily-cash-report/outlet/?outlet=${outletToUse}`;
    }

    axios
      .get(url)
      .then((res) => {
        console.log(res?.data);
        const resData = res?.data?.data?.data;
        // setDailyReportAll(res?.data?.data);
        setDailyReport(resData);
        console.log(resData, "data 83");
        // setMainReportLength(res?.data?.data?.data);
        // setTotalSale(resData?.map((data) => parseInt(data?.total_amount ? data?.total_amount :0)));
        setIsLoading(false);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
        setIsLoading(false);
        if (
          message === "Invalid token." ||
          JSON.parse(err?.request?.response)?.code === 401
        ) {
          // history.push('/login')
          logout_func2(setOnlogoutHide, history);
        }
      });
  };

  

  useEffect(() => {
    getOutletList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch report when outlet or dates change
  useEffect(() => {
    // Compute effective outlet ID
    const currentEffectiveOutletId = selectedOutlet || userOutletId;
    
    // Only fetch if outlet is available
    if (!currentEffectiveOutletId) {
      return;
    }

    // Fetch with dates if available, otherwise fetch without dates
    fetchReport(date1, date2, currentEffectiveOutletId);
    // Note: userOutletId is stable (from localStorage), so we don't need it in deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOutlet, date1, date2]);
  


  // console.log(date1, date2);
  const HandlePrint = useReactToPrint({
    content: () => cRef.current,
    documentTitle: "Daily Sales Report",
    // onAfterPrint: () => swal("Printed"),
    bodyClass: "dis",
  });
  const handlePrints = () => {
    HandlePrint();
  };

  const keys = ["", "Cash", "invoice_date"];
  const getData = dailyReport?.filter((p) =>
    keys.some((key) => p[key]?.toString().toLowerCase().includes(query))
  );
  const pageCount = Math.ceil(getData?.length / usersPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
    localStorage.setItem("saleReportPageNbr", selected);
  };
  if (!has_permissions(can_view_report)) {
    return <Permission />;
  }
  // Show loader when outlets are being fetched OR when report data is being fetched
  if (isLoadingOutlets) {
    return <Loader />;
  }

  const containerStyle = {
    margin: "-10px auto 0 auto",
    paddingBottom: "30px",
    height: "100%",
    paddingLeft: "37px",
    paddingTop: "15px",
    backgroundColor: "#FAFAFA",
  };

  return (
    <div style={containerStyle}>
      <div className="bg-white me-lg-4 me-md-3 me-1 px-3 rounded">
        <div className="py-3 d-flex justify-content-between align-items-center">
          <div className="d-flex align-self-center gap-4">
            <div>
              <h5>Daily Cash Report</h5>
              <input
                type="text"
                style={{ color: "black" }}
                className="filter-input"
                placeholder="Search here"
                onChange={(e) => {
                  const selected = 0;
                  changePage({ selected });
                  setQuery(e.target.value.toLocaleLowerCase());
                  localStorage.setItem("saleReportPageNbr", selected);
                  // (updatedPageNumber = selected)
                }}
              />
            </div>
          </div>
          <div className="d-flex align-items-start">
            <div className="me-3 mb-3 mb-md-0">
              <p className="">Outlets :</p>
              <div
                className="sl"
                style={{ width: "220px", marginTop: "-15px" }}
              >
                <Select
                  onChange={handleOutletChange}
                  options={outletList}
                  placeholder="---Select Outlet---"
                  value={
                    effectiveOutletId
                      ? outletList.find(
                          (opt) => opt.value === effectiveOutletId
                        ) || null
                      : null
                  }
                />
              </div>
            </div>
            <div className="mt-md-4 mt-2">
              
              <DatePicker
                format="MM/DD/YYYY"
                allowClear={true}
                className="date-input"
                placeholder="mm/dd/yyyy"
                style={{ width: 140, height: 40 }}
                value={date1 ? dayjs(date1, "MM/DD/YYYY") : null}
                onChange={(_, dateString) => {
                  const selectedDate = Array.isArray(dateString)
                    ? dateString[0]
                    : dateString;
                  setDate1(convertPickerDateToApiDate(selectedDate));
                  setPageNumber(0);
                }}
              />
              <span className="mx-2 my-auto" placeholder="09-09-2022">
                {" "}
                To
              </span>
              <DatePicker
                format="MM/DD/YYYY"
                allowClear={true}
                className="date-input"
                placeholder="mm/dd/yyyy"
                style={{ width: 140, height: 40 }}
                value={date2 ? dayjs(date2, "MM/DD/YYYY") : null}
                onChange={(_, dateString) => {
                  const selectedDate = Array.isArray(dateString)
                    ? dateString[0]
                    : dateString;
                  setDate2(convertPickerDateToApiDate(selectedDate));
                  setPageNumber(0);
                }}
              />
            </div>

            <div
              className="button-div my-auto ms-2 px-3 py-2 text-white rounded"
              style={{ background: "black", cursor: "pointer" }}
            >
              {/* {getData ? (
                <>
                  <a
                    rel="noreferrer"
                    style={{ color: "white" }}
                    href={`${BASE_URL}api/v1/sales/inventory/daily-cash-report/outlet/?query=${query}&start=${date1}&end=${date2}&outlet=${userProfile?.outlet}&export=true`}
                    target="_blank"
                  >
                    Export
                  </a>
                </>
              ) : (
                <>
                  <span
                    onClick={() =>
                      swal({
                        title: "Error!",
                        text: "There Is No Data",
                      })
                    }
                  >
                    {" "}
                    Export
                  </span>
                </>
              )} */}

              <HelperExportComponent
                url={`${BASE_URL}api/v1/sales/inventory/daily-cash-report/outlet/?query=${query}&start=${date1}&end=${date2}&outlet=${
                  effectiveOutletId || ""
                }&export=true`}
                fileName={"cash_report_export_file.xlsx"}
                items_data={getData}
              />

              {/* <a
                style={{ color: "white" }}
                href={`${BASE_URL}api/v1/sales/inventory/export/daily-report/outlet/`}
                target="_blank"
              >
                Export
              </a> */}
            </div>
          </div>
        </div>
        <div style={{ display: "block", overflowX: "auto" }}>
          <table className="table_my pdf-table my-4" ref={cRef}>
            <thead className="d-none thed">
              Daily Report -- Date:{" "}
              {date1 && date2 ? `${date1} - ${date2}` : currentDate}
              <span style={{ marginLeft: "15px" }}>
                {/* Total Sale :৳{finalSale} */}
              </span>
            </thead>
            <thead
              className="bg-dark text-white head-row"
              style={{ height: "50px", borderTopLeftRadius: "20px !important" }}
            >
              <tr className="">
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "180px",
                    textAlign: "center",
                  }}
                >
                  Date
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "150px",
                  }}
                >
                  Cash
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "150px",
                  }}
                >
                  Card
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "100px",
                  }}
                >
                  Bank
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "100px",
                  }}
                >
                  Bkash
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "100px",
                  }}
                >
                  Nagad
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "100px",
                  }}
                >
                  Rocket
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "200px",
                  }}
                >
                  Total Cash Recieved
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "200px",
                  }}
                >
                  Change Amount
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "200px",
                  }}
                >
                  Total Amount
                </th>
              </tr>
            </thead>
            <tbody className="tb">
              {isLoading ? (
                <tr>
                  <td colSpan="10">
                    <div className="d-flex justify-content-center align-items-center py-4">
                      <Loader />
                    </div>
                  </td>
                </tr>
              ) : getData?.length !== 0
                ? getData
                    ?.slice(pagesVisited, pagesVisited + usersPerPage)
                    .map((report) => (
                      <tr className="table-row">
                        <td className="text-center">{report.invoice_date}</td>
                        <td>৳{report?.Cash}</td>
                        <td>৳{report?.Card}</td>
                        <td>৳{report?.Bank}</td>
                        <td>৳{report?.Bkash}</td>

                        <td>৳{report?.Nagad}</td>
                        <td>৳{report?.Rocket}</td>
                        <td>৳{report?.total_cash_recieved}</td>
                        <td>৳{report?.change_amount}</td>
                        <td>৳{report?.total_amount}</td>
                      </tr>
                    ))
                : Showdata && (
                    <tr>
                      <td colspan="9">
                        <div className="not_found d-flex justify-content-center align-items-center py-4">
                          <h4 className="my-4">No Data Found</h4>
                        </div>
                      </td>
                    </tr>
                  )}
            </tbody>
          </table>
        </div>
        {getData?.length > 0 && (
          <div>
            <div
              className="row pag"
              style={{ marginTop: "30px", paddingBottom: "30px" }}
            >
              <div className="col-6 col-md-5">
                <p
                  className="inter"
                  style={{ color: "#AEAEB2", fontSize: "16px" }}
                >
                  Total Entries:{" "}
                  <span style={{ color: "black", fontSize: "14px" }}>
                    {dailyReport?.length}
                  </span>
                </p>
              </div>
              <div className="col-12 col-md-6 d-flex paggination-button">
                <ReactPaginate
                  previousLabel={<PreviousIcon />}
                  nextLabel={<NextIcon />}
                  pageCount={pageCount}
                  onPageChange={changePage}
                  containerClassName={"paginationBttns"}
                  previousLinkClassName={"a"}
                  nextLinkClassName={"a"}
                  disabledClassName={"paginationDisabled"}
                  activeClassName={"paginationActive"}
                  initialPage={query?.length > 0 ? 0 : updatedPageNumber}
                  forcePage={
                    query?.length > 0 || getData?.length < usersPerPage
                      ? 0
                      : updatedPageNumber
                  }
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OutletCashReport;
